import { configurationSettings, LoyaltyMemberIdentifier } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { captchaFieldDisplayTextValidator, defaultCaptchaFieldDisplayText } from '../../../../subcomponents/form/field/captcha/types/display-text';
import { checkboxFieldDisplayTextValidator } from '../../../../subcomponents/form/field/checkbox/types/display-text';
import { inputFieldDisplayTextValidator } from '../../../../subcomponents/form/field/input/types/display-text';
import { InvalidFieldNameError } from '../../../../types/invalid-field-name-error';
import { defaultMemberSignInFormEmailFieldDisplayText, defaultMemberSignInFormPasswordFieldDisplayText, defaultMemberSignInFormRememberFieldDisplayText, defaultMemberSignInFormUsernameFieldDisplayText } from './display-text';
import { MemberSignInFormFieldName } from './name';
const memberSignInFormInputFieldPropsValidator = Validator.object({
    name: Validator.oneOf([MemberSignInFormFieldName.Identifier, MemberSignInFormFieldName.Password]),
    displayText: inputFieldDisplayTextValidator
});
const memberSignInFormCheckboxFieldPropsValidator = Validator.object({
    name: Validator.isEqualTo(MemberSignInFormFieldName.Remember),
    displayText: checkboxFieldDisplayTextValidator
});
const memberSignInFormCaptchaFieldPropsValidator = Validator.object({
    name: Validator.isEqualTo(MemberSignInFormFieldName.Captcha),
    displayText: captchaFieldDisplayTextValidator
});
export const memberSignInFormFieldPropsValidator = Validator.any([
    memberSignInFormInputFieldPropsValidator,
    memberSignInFormCheckboxFieldPropsValidator,
    memberSignInFormCaptchaFieldPropsValidator
]);
const defaultEmailFieldProps = {
    name: MemberSignInFormFieldName.Identifier,
    displayText: defaultMemberSignInFormEmailFieldDisplayText
};
const defaultUsernameFieldProps = {
    name: MemberSignInFormFieldName.Identifier,
    displayText: defaultMemberSignInFormUsernameFieldDisplayText
};
const defaultPasswordFieldProps = {
    name: MemberSignInFormFieldName.Password,
    displayText: defaultMemberSignInFormPasswordFieldDisplayText
};
const defaultRememberFieldProps = {
    name: MemberSignInFormFieldName.Remember,
    displayText: defaultMemberSignInFormRememberFieldDisplayText
};
const defaultCaptchaFieldProps = {
    name: MemberSignInFormFieldName.Captcha,
    displayText: defaultCaptchaFieldDisplayText
};
export const defaultMemberSignInFormFieldPropsProvider = props => {
    switch (props.name) {
        case MemberSignInFormFieldName.Identifier: {
            return configurationSettings.data.loyalty.authentication.memberIdentifier === LoyaltyMemberIdentifier.Email
                ? defaultEmailFieldProps
                : defaultUsernameFieldProps;
        }
        case MemberSignInFormFieldName.Password:
            return defaultPasswordFieldProps;
        case MemberSignInFormFieldName.Remember:
            return defaultRememberFieldProps;
        case MemberSignInFormFieldName.Captcha:
            return defaultCaptchaFieldProps;
        default:
            throw new InvalidFieldNameError('MemberSignInFormField', props.name);
    }
};
//# sourceMappingURL=props.js.map